/**
 * Capacity scope (Brett, 2026-10-06): only assignment hours on projects
 * in the chosen board bands count toward capacity — the /capacity people
 * ledger, the 13-week outlook, and project Team cards all read the same
 * setting (`capacity_tiers`, edited on Admin). Today: Top 10 only; he can
 * add Just Do when he wants in-flight small work to count.
 */
export const CAPACITY_BANDS: Array<{ key: string; label: string; hint: string }> = [
  { key: "top10", label: "Top 10", hint: "the ranked Top 10 on the board" },
  { key: "just_do", label: "Just Do", hint: "approved small work running alongside the Top 10" },
];
export const DEFAULT_CAPACITY_TIERS = new Set(["top10"]);

export function parseCapacityTiers(value: string | null | undefined): Set<string> {
  const tiers = (value ?? "").split(",").map((t) => t.trim().toLowerCase()).filter(Boolean);
  return tiers.length ? new Set(tiers) : new Set(DEFAULT_CAPACITY_TIERS);
}

export function serializeCapacityTiers(tiers: Set<string>): string {
  return CAPACITY_BANDS.map((b) => b.key).filter((k) => tiers.has(k)).join(",");
}

type ScopedProject = { priority_tier?: string | null; archived_at?: string | null; status?: string | null };

/** Does this project's assignment hours count toward capacity? */
export function countsForCapacity(p: ScopedProject | undefined, tiers: Set<string>): boolean {
  if (!p || p.archived_at) return false;
  if ((p.status ?? "").toLowerCase() === "complete") return false;
  return tiers.has((p.priority_tier ?? "").toLowerCase());
}

export function capacityScopeLabel(tiers: Set<string>): string {
  const names = CAPACITY_BANDS.filter((b) => tiers.has(b.key)).map((b) => b.label);
  return names.length ? names.join(" + ") : "nothing";
}
